import {
  REQUEST_SHIP_FROM_ORDERS,
  FETCH_SHIP_FROM_ORDERS_SUCCESS,
  FETCH_SHIP_FROM_ORDERS_FAILURE,
} from '../actions/type';

const INITIAL_STATE = {
  msoTotalPages: null,
  all: null,
  currentSalesOrder: null,
  currentSalesOrderDetail: null,
  currentSalesOrderDetailByNum: null,
  isLoading: true,
  error: null,
  detailIsLoading: false,
  detailByNumIsLoading: false,
  detailError: null,
  detailByNumError: null,
  salesOrderIsCreating: false,
  salesOrderCreateError: null,
  salesOrderCreated: false,
  salesOrderIsEditing: false,
  salesOrderEditError: null,
  salesOrderEdited: false,
  customerOrderSchedules: [],
  customerOrderSchedulesIsLoading: false,
  customerOrderSchedulesError: null,
  todaysOutgoingOrders: [],
  todaysOutgoingOrdersIsLoading: null,
  todaysOutgoingOrdersError: null,
  salesOrderLineWeights: [],
  salesOrderLineWeightsIsLoading: false,
  salesOrderLineWeightsError: null,
  salesOrderLineWeightsIsEditing: false,
  editSalesOrderLineWeightsError: null,
  editSalesOrderLineWeightsSuccess: false,
  printForm: null,
  printFormIsLoading: false,
  printFormError: null,
  csv: null,
  csvIsLoading: false,
  csvError: null,
  SavingPosSale: false,
  SavePosSaleSuccessful: null,
  SavePosSaleFailure: null,
  SavePosError: null,
  InvalidCharacterEntered: false,
  ChargeNotMet: false,
  RequestingDraft: null,
  DraftDetails: null,
  DraftError: null,
  drafts: null,
  draftsIsLoading: null,
  draftsError: null,
  customerPricesIsLoading: false,
  customerPricesError: null,
  customerPrices: [],
  currencyRates: null,
  currencyRatesIsLoading: false,
  currencyRatesError: null,
  multiCurrenciesIsEditing: false,
  multiCurrenciesEdited: false,
  multiCurrenciesEditError: null,
  taxRates: null,
  taxRatesIsLoading: false,
  taxRatesError: null,
  creatingTaxRate: false,
  createTaxRateError: null,
  createTaxRateSuccess: null,
  multiTaxesIsEditing: false,
  multiTaxesEdited: false,
  multiTaxesEditError: null,
  taxIsDeleting: false,
  taxDeleted: false,
  taxDeleteError: null,
  overallSales: [],
  overallSalesIsLoading: false,
  overallSalesError: null,
  posReport: [],
  posReportIsLoading: false,
  posReportError: null,
  salesInventoryInfo: [],
  salesInventoryInfoIsLoading: false,
  salesInventoryInfoError: null,
  salesCustomerDetails: null,
  salesShippingCustomerDetails: null,
  salesCustomerDetailsIsLoading: false,
  allShipping: null,
  allShippingIsLoading: false,
  allShippingError: null,
  purchasesVendorDetailsError: null,
  purchasesVendorDetails: null,
  purchasesVendorDetailsIsLoading: false,
  salesCustomerDetailsError: null,
  salesItemHistory: [],
  salesItemHistoryIsLoading: false,
  salesItemHistoryError: null,
  customerSalesHistory: [],
  customerSalesHistoryIsLoading: false,
  customerSalesHistoryError: null,
  customerFrequent: [],
  customerFrequentIsLoading: false,
  customerFrequentError: null,
  salesOrdersFilter: null,
  salesPerformanceIsLoading: false,
  salesPerformance: null,
  salesPerformanceError: null,
  dashboardSalesDetail: null,
  dashboardSalesDetailIsLoading: false,
  dashboardSalesDetailError: null,
  salesLevels: {},
  salesLevelsIsLoading: false,
  salesLevelsError: null,
  salesOrderProduct: null,
  salesOrderProductIsLoading: false,
  salesOrderProductFailure: null,

  requestingShippingList: false,
  shippingListPDF: null,
  requestingPackingList: false,
  packingListPDF: null,
  requestingPickingList: false,
  pickingListPDF: null,
  requestingSalesOrderPDF: false,
  salesOrderPDF: null,
  requestingBolIdPDF: false,
  bolIdPDF: null,
  requestingBolWithoutLogPDF: false,
  bolWithoutLogPDF: null,
  requestingBolLabel: false,
  bolLabel: null,
  requestingBolFbaPDF: false,
  bolFbaPDF: null,
  spPDF: null,
  bolAddress: [],
  requestingRefundPDF: false,
  refundPDF: null,
  prevEstDate: null,
  prevEstDateIsNeeded: false,
  // Refund related reducer
  refund: { error: null, loading: false, status: 0 },
  quoteLoading: false,
  salesTotals: null,
  salesTotalsIsLoading: false,
  salesTotalsError: null,
  userPerformanceIsLoading: false,
  userPerformanceError: null,
  userPerformanceData: {},
  batchesInfo: {},
};

export default function (state = INITIAL_STATE, action) {
  // console.log("action.payload:", action);
  switch (action.type) {
    case REQUEST_SHIP_FROM_ORDERS:
      return { ...state, error: null, isLoading: true };
    case FETCH_SHIP_FROM_ORDERS_SUCCESS:
      return {
        ...state, all: action.payload.data, error: null, isLoading: false, msoTotalPages: action.payload.data ? action.payload.data.pages : 1,
      };
    case FETCH_SHIP_FROM_ORDERS_FAILURE: {
      const error = action.payload || { message: action.payload.message };
      return {
        ...state, all: [], error, isLoading: false,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/shipFromOrders_reducer.js